import ajax from "@/libs/Ajax";

export default {
  blocklist(params) {
    return ajax.get("/aseapi/console/sysmgr/block/list", {
      params: params
    });
  },

  delBlock(params) {
    return ajax.post("/aseapi/console/sysmgr/block/delblocks", params);
  },

  delAllBlock(params) {
    return ajax.delete("/aseapi/console/sysmgr/block/delall", params);
  },

  interruptBlock(params) {
    return ajax.post("/aseapi/console/sysmgr/block/interruptBlockingMsg", params);
  }
};
